module.exports = __webpack_public_path__ + "img/atomic.64216e82.png";